exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-employee {\n  width: 1000px;\n  margin: 1em auto;\n  background: white;\n  clear: both; }\n  .add-employee .add-employee-form {\n    margin-left: 2em;\n    padding-bottom: 2em;\n    overflow: hidden; }\n  .add-employee .error {\n    float: left;\n    clear: both;\n    overflow: hidden;\n    margin-top: .4em;\n    min-height: 1.7em;\n    width: 20em;\n    font-size: .9em;\n    color: #d60300; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/employees/views/addEditEmployeeView/addEditEmployeeView.component.scss
// module id = ./src/app/modules/employees/views/addEditEmployeeView/addEditEmployeeView.component.scss
// module chunks = main